import {ICategory, ICountCategory, IRootCategory} from '../contract/category.contract';
import { SearchQuery } from '../model/search-query';
import { IDocumentSearchResult } from '@/contract/search.contract';
import { SearchSuggestion } from '@/contract/suggestion.contract';
import Axios from 'axios';
import { Constants } from '@/constants';
import { IncomingSearchSuggestion } from '../contract/suggestion.contract';
import { analyticsEventService } from '@/services/analytics/analytics-event.service';
import { AnalyticsEventName, AnalyticsEventCategory } from '@/services/analytics/analytics.contract';

class SearchApiService {
  public async getSuggestions(queryString: string): Promise<SearchSuggestion[]> {
    if (!queryString) {
      return [];
    }
    const axiosResult = await Axios.get<IncomingSearchSuggestion[]>(`${Constants.ApiBaseUrl}suggestions`, {
      params: {
        q: queryString,
      },
    });
    return axiosResult.data.reduce((suggestions: SearchSuggestion[], incomingSuggestion) => {
      return [
        ...suggestions,
        ...incomingSuggestion.labels.map((label) => ({
          suggestionType: incomingSuggestion.suggestionType,
          suggestionLabel: label,
        })),
      ];
    }, []);
  }

  public async searchDocuments(searchQuery: SearchQuery): Promise<IDocumentSearchResult> {
    const apiResult = await Axios.post<IDocumentSearchResult>(`${Constants.ApiBaseUrl}search`, searchQuery.toApi());
    const searchResult = apiResult.data;
    for (const key in searchQuery.filters) {
      searchResult.filterGroups
        .find((fg) => fg.id === key)
        ?.children.forEach((f) => (f.isSelected = searchQuery.filters[key].includes(f.id)));
    }
    searchResult.filterGroups = searchResult.filterGroups.filter((group) => group.children.length > 0);

    analyticsEventService.trackSearchResult(searchQuery.freeTextSearchTerm || '', searchResult.count);

    return searchResult;
  }

  public async getCategories(): Promise<IRootCategory[]> {
    const axiosResult = await Axios.get<IRootCategory[]>(`${Constants.ApiBaseUrl}categories`);
    return axiosResult.data;
  }

  public async getVisibleCategories(): Promise<ICountCategory[]> {
    const axiosResult = await Axios.get(`${Constants.ApiBaseUrl}categories/visible`);
    return axiosResult.data.categories;
  }

  public async filterVisibleCategories(): Promise<IRootCategory[]> {
    const visibleCategories = await this.getVisibleCategories();
    const allCategories = await this.getCategories();

    return allCategories.map((rootCategory) => {
      const filteredCategories = rootCategory.children.map((category) => {
        const filteredSubCategories = category.children.filter((subCategory) => visibleCategories.some((visibleCategory) => visibleCategory.term === subCategory.term));
        return { name: category.name, children: filteredSubCategories };
      });
      return {
        term: rootCategory.term,
        name: rootCategory.name,
        children: filteredCategories.filter(cat => cat.children.length > 0 ),
      };
    });
}
}

export const searchApiService = new SearchApiService();
